import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { timeout, catchError, mergeMap, retryWhen } from 'rxjs/operators';

@Injectable()
export class HttpTimeoutRetryInterceptor implements HttpInterceptor {
  private readonly DEFAULT_TIMEOUT_MS = 30000; // 30 segundos
  private readonly LONG_TIMEOUT_MS = 90000; // 90 segundos para endpoints pesados
  private readonly MAX_RETRIES = 2;

  // Endpoints que precisam de timeout maior (backend lento)
  private readonly LONG_TIMEOUT_PATTERNS = [
    '/Client/graph',
  ];

  private getTimeout(url: string): number {
    if (this.LONG_TIMEOUT_PATTERNS.some(p => url.includes(p))) {
      return this.LONG_TIMEOUT_MS;
    }
    return this.DEFAULT_TIMEOUT_MS;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutMs = this.getTimeout(req.url);

    return next.handle(req).pipe(
      timeout(timeoutMs),
      retryWhen(errors =>
        errors.pipe(
          mergeMap((error: HttpErrorResponse, index: number) => {
            if (index >= this.MAX_RETRIES) {
              return throwError(() => error);
            }
            // Retry em erros de servidor, rede ou timeout
            const isRetryable = error.status === 0
              || (error.status >= 500 && error.status < 600)
              || (error as any).name === 'TimeoutError';
            if (isRetryable) {
              const delay = 1500 * (index + 1); // 1.5s, 3s
              console.log(`🔄 Retry ${index + 1}/${this.MAX_RETRIES} em ${delay}ms: ${req.url}`);
              return timer(delay);
            }
            return throwError(() => error);
          })
        )
      ),
      catchError((error) => {
        if (error.name === 'TimeoutError') {
          console.warn(`⏱️ Request timeout (${timeoutMs}ms):`, req.url);
        }
        return throwError(() => error);
      })
    );
  }
}
